
export class CacheItem {
    CreatedDateTimeTicks: number = -1;
    ValidUptoDateTimeTicks: number = -1;
    AccessKey: string = '';
    Data: any;
}